import React from "react";
import { ProgressBar } from "@react-native-community/progress-bar-android";

const CustomProgressBar = ({
  style = {
    width: "100%",
    marginVertical: 8,
  },
}) => {
  return <ProgressBar style={style} styleAttr="Horizontal" />;
};

export default CustomProgressBar;
